import React, { memo } from 'react';
import {useState} from 'react';
import { Handle } from 'react-flow-renderer';

import speechToText from '../img/speechToText.png'
import DesignCard from './DesignCard';
export default memo(({ data }) => {

    
    var style = {
        background:'gold',
        color:'purple',
        textAlign:'center',
        width:50,
        height:50
    
    } 


    return (
    <div className='designnode'>
      <Handle
        type="target"
        position="top"
        // style={{ background: '#555' }}
        onConnect={(params) => console.log('handle onConnect', params)}
      />
      <img draggable={false} src={speechToText} width='50' height='50'></img>
      {/* <h4>{data.label}  </h4>  */}
      <DesignCard attributes={data.attributes} name={data.label}/>

      <Handle
        type="source"
        position="bottom"
        id="b2"
        style={{ bottom: -5, top: 'auto', background: '#555' }}
      />


    </div>
  );
});